export const ABORTED = 'aborted';
export const RUNNING = 'running';
export const IDLE = 'idle';
export const WAITING = 'waiting';
